var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInboxActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.96875 0.125C0.881836 0.125 0 1.00684 0 2.09375C0 2.71309 0.291211 3.29551 0.7875 3.66875L9.7125 10.3625C10.1801 10.7111 10.8199 10.7111 11.2875 10.3625L20.2125 3.66875C20.7088 3.29551 21 2.71309 21 2.09375C21 1.00684 20.1182 0.125 19.0312 0.125H1.96875ZM0 4.71875V13.25C0 14.6979 1.17715 15.875 2.625 15.875H18.375C19.8229 15.875 21 14.6979 21 13.25V4.71875L12.075 11.4125C11.1398 12.1139 9.86016 12.1139 8.925 11.4125L0 4.71875Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxActiveIcon);
export default __webpack_public_path__ + "static/media/inbox-active-icon.0d44386ca2c27b6aecc0fca2026d35b3.svg";
export { ForwardRef as ReactComponent };